import React from "react";
import { IPopupState, defaultPopupState } from "./PopupStateInterface";

export const PopupContext = React.createContext<IPopupState>(defaultPopupState);
export const PopupProvider = PopupContext.Provider;
export const PopupConsumer = PopupContext.Consumer;
